/*
 * R24 · Bewegung (23.09.2026) — EIN Asset, `defer`, EINMAL je Seite (layout/theme.liquid).
 *
 * 1 · Auftauchen beim Scrollen: Bänder/Karten blenden EINMAL ein (Deckkraft + 8 px), Dauer
 *     und Kurve = Haus-Tokens (--r24-dur/--r24-ease, CSS in snippets/r24-interactions).
 *     Was beim Laden schon sichtbar ist, wird nie versteckt; ohne JS, ohne
 *     IntersectionObserver und bei prefers-reduced-motion passiert nichts (alles sichtbar).
 *     Stand bis hier inline in r24-interactions (22 px, 620 ms) — dort entfernt.
 * 2 · Produkt-Rails ([data-r24-rail], sections/r24-product-rail-2026 + r24-sets-2026):
 *     a) Reihenfolge nachladen, wenn die Rail sie anders will als ihre Kollektion
 *        (data-r24-feed → sections/r24-rail-feed via Section Rendering API), kurz BEVOR
 *        sie ins Bild kommt; 30 min im sessionStorage. Scheitert es, bleibt die
 *        Server-Reihenfolge stehen (nie eine leere Rail).
 *     b) Doppelte ausblenden: Karten, deren Produkt weiter oben auf der Seite schon
 *        verlinkt ist (Hero, Sets, frühere Rail …), fallen weg — mindestens 4 bleiben.
 *     c) Tagesstart: der Startpunkt verschiebt sich je Kalendertag und Sektion
 *        (deterministisch → gecachtes HTML bleibt gültig, Wiederkehrer sehen Neues).
 *     d) Weiterblättern: alle 6 s eine Karte, NUR mit IntersectionObserver und nur,
 *        solange die Rail sichtbar ist; Pause bei Zeigen, Fokus, Berührung (dann bis
 *        „fortsetzen“), Mausrad/Tastatur (6 s), verdecktem Tab; gar nicht bei
 *        prefers-reduced-motion. Sichtbarer Anhalten-Knopf (WCAG 2.2.2).
 * Abrufe über r24Fetch (Abrufregel, gleichlautend in sechs weiteren Dateien —
 * scripts/fetch-hardening.contract.test.mjs). Vertrag: scripts/home-motion.contract.test.mjs
 */
(function () {
  'use strict';
  if (window.__r24Motion) return;
  window.__r24Motion = 1;

  var MQ = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function reduced() { return !!(MQ && MQ.matches); }
  var HAS_IO = typeof window.IntersectionObserver === 'function';
  var AUTO_MS = 6000;
  var MIN_KEEP = 4;
  var each = function (list, fn) { Array.prototype.forEach.call(list || [], fn); };

  /* R24 · Abrufregel (fetch-hardening) — gleichlautend mit sections/r24-cart u. a. */
  function r24Fetch(url, init, retry, ms){
    var ctl = typeof AbortController === 'function' ? new AbortController() : null, tm = 0, o = {}, k;
    for (k in (init || {})) o[k] = init[k];
    if (ctl){ o.signal = ctl.signal; tm = setTimeout(function(){ ctl.abort(); }, ms || 20000); }
    return fetch(url, o).then(function(r){
      return r.text().then(function(t){
        clearTimeout(tm);
        var d = null, s = r.status, wait;
        if (/^\s*[\[{]/.test(t || '')){ try { d = JSON.parse(t); } catch (e) { d = null; } }
        if (s === 429 && retry){
          wait = Math.min(4, Math.max(1, parseFloat(r.headers && r.headers.get('Retry-After')) || 1.5));
          return new Promise(function(go){ setTimeout(go, wait * 1000); }).then(function(){ return r24Fetch(url, init, false, ms); });
        }
        return { ok: r.ok, status: s, data: d, text: t || '', url: r.url || '',
          kind: r.ok ? (d ? 'ok' : 'empty') : s === 429 ? 'rate' : s >= 500 ? 'server' : 'client' };
      });
    }).then(null, function(e){
      clearTimeout(tm);
      var to = !!(e && e.name === 'AbortError');
      if (typeof console !== 'undefined') console.warn('[R24] ' + url + ': ' + (to ? 'Zeitlimit' : (e && e.message) || e));
      return { ok: false, status: 0, data: null, text: '', url: '', kind: to ? 'timeout' : 'network' };
    });
  }

  /* ------------------------------------------------------------------ 1 · Auftauchen */
  var REVEAL = '.r24h-sec,.r24h-band,.r24-mp,.r24mp,.r24cart__card,.r24mag__card,.r24sr-card,.r24ps,.r24rel,.r24col-card,[data-r24x-rv]';
  var revealIO = null, revealSeen = false, revealFailsafe = 0;
  function showAll() { each(document.querySelectorAll('.r24x-rv'), function (el) { el.classList.add('is-in'); }); }
  function reveal(scope) {
    if (reduced() || !HAS_IO) return;
    var list = (scope || document).querySelectorAll(REVEAL);
    if (!list.length) return;
    if (!revealIO) {
      revealIO = new IntersectionObserver(function (entries) {
        revealSeen = true;
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); revealIO.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.04 });
    }
    var vh = window.innerHeight || 800;
    each(list, function (el) {
      if (el.__r24rv) return;
      el.__r24rv = 1;
      if (el.getBoundingClientRect().top < vh * 0.95) return;   /* schon im Bild: nie verstecken */
      el.classList.add('r24x-rv');
      revealIO.observe(el);
    });
    /* Failsafe: meldet der Observer sich binnen 3 s gar nicht, wird alles sichtbar.
       (Vorher deckte der Timer nach 3 s ALLES auf — die Animation lief nur 3 s lang.) */
    if (!revealFailsafe) revealFailsafe = setTimeout(function () { if (!revealSeen) showAll(); }, 3000);
  }

  /* ------------------------------------------------------------------ 2 · Rails */
  function cardsOf(box) {
    return Array.prototype.filter.call(box.children || [], function (c) { return c.classList && c.classList.contains('r24h-card'); });
  }
  function productKey(href) {
    try {
      var p = new URL(href, location.href).pathname, i = p.indexOf('/products/');
      return i < 0 ? '' : p.slice(i).replace(/\/+$/, '');
    } catch (e) { return ''; }
  }
  function cardKey(card) {
    var a = card.querySelector('a[href*="/products/"]');
    return a ? productKey(a.getAttribute('href')) : '';
  }
  /* Produkte, die im Hauptinhalt VOR dieser Rail schon verlinkt sind. */
  function shownBefore(rail) {
    var main = document.getElementById('MainContent') || document.body, seen = {};
    var PRE = (window.Node && Node.DOCUMENT_POSITION_PRECEDING) || 2;
    each(main.querySelectorAll('a[href*="/products/"]'), function (a) {
      if (rail.contains(a) || !(rail.compareDocumentPosition(a) & PRE)) return;
      var k = productKey(a.getAttribute('href'));
      if (k) seen[k] = 1;
    });
    return seen;
  }
  function dedupe(rail) {
    var seen = shownBefore(rail), own = {}, cs = cardsOf(rail), keep = cs.length;
    cs.forEach(function (c) {
      var k = cardKey(c);
      if (!k) return;
      if ((seen[k] || own[k]) && keep > MIN_KEEP) { c.parentNode.removeChild(c); keep--; return; }
      own[k] = 1;
    });
  }
  function trim(rail) {
    var limit = parseInt(rail.getAttribute('data-r24-limit'), 10) || 12;
    cardsOf(rail).slice(limit).forEach(function (c) { c.parentNode.removeChild(c); });
  }
  function hash(s) { var h = 0; for (var i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0; return Math.abs(h); }
  function dayNumber() { var d = new Date(); return Math.floor(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()) / 86400000); }
  function rotate(rail) {
    if (rail.getAttribute('data-r24-rotate') !== '1') return;
    var cs = cardsOf(rail), n = cs.length;
    if (n < 2) return;
    var off = (dayNumber() + hash(rail.getAttribute('data-r24-seed') || '')) % n;
    for (var i = 0; i < off; i++) rail.appendChild(cs[i]);
  }
  function prepare(rail) { dedupe(rail); trim(rail); rotate(rail); rail.scrollLeft = 0; }

  var CACHE_MS = 30 * 60 * 1000;
  /* Schlüssel trägt die Theme-ID: nach jeder Veröffentlichung (neue Live-ID) gilt der alte Zwischenspeicher nicht mehr. */
  var CACHE_V = (window.Shopify && Shopify.theme && Shopify.theme.id) || '0';
  function cacheGet(url) {
    try {
      var o = JSON.parse(sessionStorage.getItem('r24rail:' + CACHE_V + ':' + url) || 'null');
      return o && o.h && Date.now() - o.t < CACHE_MS ? o.h : null;
    } catch (e) { return null; }
  }
  function cacheSet(url, h) { try { sessionStorage.setItem('r24rail:' + CACHE_V + ':' + url, JSON.stringify({ t: Date.now(), h: h })); } catch (e) { /* voll/gesperrt: ohne Zwischenspeicher weiter */ } }
  /* Antwort inert parsen (DOMParser): Bilder laden erst, wenn die Karten eingesetzt sind. */
  function feedCards(html) {
    if (!html || typeof DOMParser !== 'function') return [];
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var box = doc.querySelector('[data-r24-feed-cards]');
    return box ? cardsOf(box) : [];
  }
  function busy(rail, st) { return st.hover || st.focus || st.touched; }
  /* Ausgabeschutz: data-r24-allow der Rail = erlaubte Möbeltypen („|“-Liste). Nachgeladene
     Karten mit anderem data-r24-kind fallen weg, BEVOR sortiert/gedreht wird — die
     Reihenfolge darf die zulässige Menge nie erweitern (Anlass: „Küchenzeilen“ zeigte
     Bestseller-Hängeschränke). Leere Liste = keine Prüfung. */
  function allowed(rail, cards) {
    var raw = rail.getAttribute('data-r24-allow') || '';
    if (!raw) return cards;
    var ok = {};
    raw.split('|').forEach(function (t) { t = t.trim(); if (t) ok[t] = 1; });
    return cards.filter(function (c) {
      var k = (c.getAttribute('data-r24-kind') || '').trim();
      return !!k && ok[k] === 1;
    });
  }
  function applyFeed(rail, st, html) {
    var cards = allowed(rail, feedCards(html));
    if (cards.length < MIN_KEEP || busy(rail, st)) return false;
    var label = rail.getAttribute('data-r24-new-label') || '';
    var frag = document.createDocumentFragment();
    cards.forEach(function (c) {
      var n = document.importNode(c, true);
      each(n.querySelectorAll('.r24h-badge--new'), function (b) { if (label) b.textContent = label; else b.parentNode.removeChild(b); });
      frag.appendChild(n);
    });
    while (rail.firstChild) rail.removeChild(rail.firstChild);
    rail.appendChild(frag);
    prepare(rail);
    try { document.dispatchEvent(new CustomEvent('r24h:paint-wish')); } catch (e) { /* alter Browser: Herzen malt die Merkliste beim nächsten Lauf */ }
    return true;
  }

  function initRail(rail) {
    if (rail.__r24rail) return;
    rail.__r24rail = 1;
    var root = (rail.closest && rail.closest('[data-r24-rail-root]')) || rail.parentNode;
    var ctl = root.querySelector('[data-r24-rail-ctl]');
    var prev = ctl && ctl.querySelector('[data-r24-rail-prev]');
    var next = ctl && ctl.querySelector('[data-r24-rail-next]');
    var pause = ctl && ctl.querySelector('[data-r24-rail-pause]');
    var st = { visible: false, paused: false, hover: false, focus: false, touched: false, lastUser: 0 };
    var auto = rail.getAttribute('data-r24-auto') === '1';
    var timer = 0;

    function overflowing() { return rail.scrollWidth - rail.clientWidth > 4; }
    function atStart() { return rail.scrollLeft <= 4; }
    function atEnd() { return rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4; }
    function step() {
      var c = cardsOf(rail)[0];
      if (!c) return 0;
      var cs = window.getComputedStyle ? getComputedStyle(rail) : null;
      return c.getBoundingClientRect().width + (cs ? parseFloat(cs.columnGap || cs.gap) || 0 : 0);
    }
    function go(dir) {
      var s = step();
      if (s) rail.scrollBy({ left: dir * s, behavior: reduced() ? 'auto' : 'smooth' });
    }
    function advance() {
      if (atEnd()) rail.scrollTo({ left: 0, behavior: 'smooth' });
      else go(1);
    }
    function autoAllowed() { return auto && HAS_IO && !reduced(); }
    function canRun() {
      return autoAllowed() && st.visible && !st.paused && !st.hover && !st.focus && !document.hidden &&
        overflowing() && Date.now() - st.lastUser >= AUTO_MS;
    }
    function tick() { if (canRun()) advance(); }
    function sync() {
      var want = autoAllowed() && st.visible && !st.paused && !document.hidden;
      if (want && !timer) timer = setInterval(tick, AUTO_MS);
      else if (!want && timer) { clearInterval(timer); timer = 0; }
    }
    function paintPause() {
      if (!pause) return;
      pause.hidden = !autoAllowed();
      pause.classList.toggle('is-paused', st.paused);
      pause.setAttribute('aria-label', st.paused ? 'Automatisches Weiterblättern fortsetzen' : 'Automatisches Weiterblättern anhalten');
    }
    function paint() {
      if (ctl) ctl.hidden = !overflowing();
      if (prev) prev.disabled = atStart();
      if (next) next.disabled = atEnd();
      paintPause();
    }
    var raf = 0;
    function onScroll() {
      if (raf) return;
      var later = function () { raf = 0; paint(); };
      raf = window.requestAnimationFrame ? window.requestAnimationFrame(later) : setTimeout(later, 16);
    }

    /* Nutzer übernimmt → Automatik weicht. */
    function user() { st.lastUser = Date.now(); }
    rail.addEventListener('scroll', onScroll, { passive: true });
    rail.addEventListener('wheel', user, { passive: true });
    rail.addEventListener('keydown', user);
    rail.addEventListener('pointerdown', function (e) {
      user();
      if (e.pointerType === 'touch' && !st.paused) { st.touched = true; st.paused = true; paintPause(); sync(); }
    }, { passive: true });
    root.addEventListener('mouseenter', function () { st.hover = true; });
    root.addEventListener('mouseleave', function () { st.hover = false; });
    root.addEventListener('focusin', function () { st.focus = true; });
    root.addEventListener('focusout', function () {
      setTimeout(function () { st.focus = root.contains(document.activeElement); }, 0);
    });
    if (prev) prev.addEventListener('click', function () { user(); go(-1); });
    if (next) next.addEventListener('click', function () { user(); if (atEnd()) rail.scrollTo({ left: 0, behavior: reduced() ? 'auto' : 'smooth' }); else go(1); });
    if (pause) pause.addEventListener('click', function () {
      st.paused = !st.paused;
      if (!st.paused) { st.touched = false; st.lastUser = 0; }
      paintPause(); sync();
    });
    document.addEventListener('visibilitychange', sync);
    window.addEventListener('resize', onScroll);
    if (MQ) {
      var onMq = function () { paintPause(); sync(); };
      if (MQ.addEventListener) MQ.addEventListener('change', onMq); else if (MQ.addListener) MQ.addListener(onMq);
    }

    prepare(rail);
    var feed = rail.getAttribute('data-r24-feed') || '';
    var cached = feed ? cacheGet(feed) : null;
    if (cached) applyFeed(rail, st, cached);

    if (HAS_IO) {
      var loaded = !feed || !!cached;
      /* Früh nachladen (800 px vor dem Bild), damit der Tausch nicht unter den Augen passiert. */
      if (!loaded) {
        var pre = new IntersectionObserver(function (entries) {
          if (!entries.some(function (e) { return e.isIntersecting; })) return;
          pre.disconnect();
          r24Fetch(feed, { credentials: 'same-origin', headers: { Accept: 'text/html' } }, false).then(function (res) {
            if (!res.ok || !res.text) { console.warn('[R24] Rail-Reihenfolge nicht geladen (' + res.kind + ') — Kollektionsreihenfolge bleibt.'); return; }
            cacheSet(feed, res.text);
            if (applyFeed(rail, st, res.text)) paint();
          });
        }, { rootMargin: '800px 0px 800px 0px' });
        pre.observe(rail);
      }
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { st.visible = e.isIntersecting; });
        sync();
      }, { threshold: 0.5 }).observe(rail);
    }
    paint();
  }

  /* 0 · Reiter-Gruppen (Owner 02.10.2026): Rails mit gleichem data-r24-tabgroup werden an der
     Stelle der ersten zu EINER Schiene mit Reitern zusammengezogen (Startseite kürzer). Läuft VOR
     dem Rail-Start, damit Doppelte/Tagesstart die endgültige Reihenfolge sehen. Versteckte Reiter
     laufen nicht (IntersectionObserver sieht sie nicht). Tastatur: ←/→/Pos1/Ende. */
  function groupTabs() {
    var groups = {}, names = [];
    each(document.querySelectorAll('[data-r24-tabgroup]'), function (sec) {
      var g = sec.getAttribute('data-r24-tabgroup');
      if (!g || sec.closest('.r24rt')) return;
      if (!groups[g]) { groups[g] = []; names.push(g); }
      groups[g].push(sec);
    });
    names.forEach(function (g, gi) {
      var secs = groups[g];
      if (secs.length < 2) return;
      var outer = function (s) { return s.closest('[id^="shopify-section"]') || s; };
      var box = document.createElement('div');
      box.className = 'r24rt';
      var first = outer(secs[0]);
      first.parentNode.insertBefore(box, first);
      var bar = document.createElement('div');
      bar.className = 'r24h r24h-sec r24rt__bar';
      bar.innerHTML = '<div class="r24h-wrap"><span class="r24h-eyebrow"></span><div class="r24rt__tabs" role="tablist"></div></div>';
      bar.querySelector('.r24h-eyebrow').textContent = g;
      var list = bar.querySelector('[role="tablist"]');
      list.setAttribute('aria-label', g);
      box.appendChild(bar);
      var tabs = [];
      secs.forEach(function (sec, i) {
        var o = outer(sec), id = 'r24rt-' + gi + '-' + i;
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'r24rt__tab'; b.id = id + '-t';
        b.setAttribute('role', 'tab'); b.setAttribute('aria-controls', id);
        b.textContent = sec.getAttribute('data-r24-tabname') || ('Auswahl ' + (i + 1));
        list.appendChild(b); tabs.push(b);
        sec.id = sec.id || id; b.setAttribute('aria-controls', sec.id);
        sec.setAttribute('role', 'tabpanel'); sec.setAttribute('aria-labelledby', b.id);
        sec.classList.add('r24rt__panel');
        box.appendChild(o);
      });
      function show(n, focus) {
        tabs.forEach(function (t, i) {
          var on = i === n, o = outer(secs[i]);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          if (on) o.removeAttribute('hidden'); else o.setAttribute('hidden', '');
        });
        if (focus) tabs[n].focus();
        try { window.dispatchEvent(new Event('resize')); } catch (e) { /* alter Browser: Rail misst beim nächsten Scrollen */ }
      }
      list.addEventListener('click', function (e) {
        var t = e.target.closest('.r24rt__tab'); if (t) show(tabs.indexOf(t), false);
      });
      list.addEventListener('keydown', function (e) {
        var i = tabs.indexOf(document.activeElement); if (i < 0) return;
        var n = e.key === 'ArrowRight' ? (i + 1) % tabs.length : e.key === 'ArrowLeft' ? (i - 1 + tabs.length) % tabs.length
          : e.key === 'Home' ? 0 : e.key === 'End' ? tabs.length - 1 : -1;
        if (n < 0) return;
        e.preventDefault(); show(n, true);
      });
      show(0, false);
    });
  }

  function scan(scope) {
    each((scope || document).querySelectorAll('[data-r24-rail]'), initRail);
    reveal(scope);
  }
  function boot() { groupTabs(); scan(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  if (MQ) {
    var onReduce = function () { if (reduced()) showAll(); };
    if (MQ.addEventListener) MQ.addEventListener('change', onReduce); else if (MQ.addListener) MQ.addListener(onReduce);
  }
  /* Nachgeladene Inhalte (Warenkorb-Updates, Theme-Editor) ebenfalls erfassen. */
  document.addEventListener('t4s:cart:updated', function () { setTimeout(function () { reveal(document); }, 250); });
  document.addEventListener('cart:updated', function () { setTimeout(function () { reveal(document); }, 250); });
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
